import actions from '../actions';

export const initState = {
  selected_vendor: null,
  vendors: [],
  loading: false
};

export default function vendorReducer(state = initState, action) {
  switch (action.type) {
    case actions.vendor.INIT:
      return { ...initState };
    case actions.vendor.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
